// src/admin/pages/AdminSegments.js
import React, { useEffect, useState, useContext } from "react";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import {
  getAdminCustomerSegments,
  sendSegmentEmailCampaign,
} from "../../services/adminSegments.api";
import { FaSearch, FaUsers } from "react-icons/fa";
import {
  FiDownload,
  FiMail,
  FiMessageCircle,
  FiChevronRight
} from "react-icons/fi";

function AdminSegments() {
  const { lang } = useContext(AdminLanguageContext);
  const t = (en, ar) => (lang === "EN" ? en : ar);
  const [isOpen, setIsOpen] = useState(false);
  const [segments, setSegments] = useState([]);
  const [selectedSegment, setSelectedSegment] = useState(null);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  const [bulkType, setBulkType] = useState(null); // "or" | "and"

  const [showActions, setShowActions] = useState(false);
const [showExport, setShowExport] = useState(false);
const [showEmailModal, setShowEmailModal] = useState(false);
const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);

// EMAIL
const [emailSubject, setEmailSubject] = useState("");
const [emailBody, setEmailBody] = useState("");
const [selectedEmails, setSelectedEmails] = useState({});

const [emailSending, setEmailSending] = useState(false);
const [emailError, setEmailError] = useState("");
const [emailSuccess, setEmailSuccess] = useState("");

// WHATSAPP
const [whatsappMessage, setWhatsappMessage] = useState("");
const [sentWhatsApp, setSentWhatsApp] = useState({});

  // ADD STATE
const [segmentSearch, setSegmentSearch] = useState("");
const [selectedSegments, setSelectedSegments] = useState([]);
const [bulkMode, setBulkMode] = useState(false);

const [page, setPage] = useState(1);
const perPage = 10;

  

  useEffect(() => {
  const handleClick = (e) => {
    if (
      !e.target.closest(".actions-overlay") &&
      !e.target.closest(".actions-button")
    ) {
      setShowActions(false);
    }
  };

  if (showActions) {
    document.addEventListener("mousedown", handleClick);
  }

  return () => document.removeEventListener("mousedown", handleClick);
}, [showActions]);

  useEffect(() => {
  setPage(1);
}, [selectedSegment, bulkMode, search]);

  useEffect(() => {
    getAdminCustomerSegments()
      .then(setSegments)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const exportPDF = () => {
  const doc = new jsPDF();

  const tableColumn = ["Name", "Email", "Phone", "Location", "Orders", "Spent"];
  const tableRows = [];

  filteredCustomers.forEach(c => {
    tableRows.push([
  c.name,
  c.email || "",
  c.phone || "",
  c.location || "",
  c.orders,
  `$${c.totalSpent}`
]);
  });

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
  });

  doc.save("customers.pdf");
};

  const exportExcel = () => {
  const data = filteredCustomers.map(c => ({
  Name: c.name,
  Email: c.email || "",
  Phone: c.phone || "",
  Location: c.location || "",
  Orders: c.orders,
  Spent: c.totalSpent,
}));

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

  XLSX.writeFile(workbook, "customers.xlsx");
};

  const exportCSV = () => {
  const headers = ["Name", "Email", "Phone", "Location", "Orders", "Spent"];

  const rows = filteredCustomers.map(c => [
  c.name,
  c.email || "",
  c.phone || "",
  c.location || "",
  c.orders,
  c.totalSpent
]);

  let csvContent =
    "data:text/csv;charset=utf-8," +
    [headers, ...rows].map(e => e.join(",")).join("\n");

  const link = document.createElement("a");
  link.href = encodeURI(csvContent);
  link.download = "customers.csv";
  link.click();
};

  // filter segments by name
const filteredSegments = segments.filter((s) =>
  s.name.toLowerCase().includes(segmentSearch.toLowerCase())
);

const toggleEmail = (id) => {
  setSelectedEmails(prev => ({
    ...prev,
    [id]: !prev[id]
  }));
};

const handleSendWhatsApp = (id) => {
  setSentWhatsApp(prev => ({
    ...prev,
    [id]: true
  }));

  // later: API call here
};

// toggle checkbox
const toggleSegment = (segment) => {
  setSelectedSegments((prev) => {
    const exists = prev.find((s) => s.id === segment.id);
    if (exists) {
      return prev.filter((s) => s.id !== segment.id);
    }
    return [...prev, segment];
  });
};

const allSelected =
  filteredSegments.length > 0 &&
  filteredSegments.every((s) =>
    selectedSegments.some((x) => x.id === s.id)
  );

const toggleAllSegments = () => {
  if (allSelected) {
    // unselect all visible
    setSelectedSegments((prev) =>
      prev.filter(
        (s) => !filteredSegments.some((fs) => fs.id === s.id)
      )
    );
  } else {
    // select all visible
    const merged = [
      ...selectedSegments,
      ...filteredSegments.filter(
        (s) => !selectedSegments.some((x) => x.id === s.id)
      ),
    ];
    setSelectedSegments(merged);
  }
};

// bulk customers (deduplicated)
const bulkCustomers = (() => {
  if (!selectedSegments.length) return [];

  // OR → union (your current logic)
  if (bulkType === "or") {
    return Array.from(
      new Map(
        selectedSegments
          .flatMap((s) => s.customers)
          .map((c) => [c.id, c])
      ).values()
    );
  }

  // AND → intersection
  if (bulkType === "and") {
    return selectedSegments
      .map((s) => s.customers)
      .reduce((acc, curr) => {
        return acc.filter((c1) =>
          curr.some((c2) => c2.id === c1.id)
        );
      });
  }

  return [];
})();

const segmentNamesAND = selectedSegments.map(s => s.name).join(" and ");
const segmentNamesOR = selectedSegments.map(s => s.name).join(", ");

  const sourceCustomers = bulkMode
  ? bulkCustomers
  : selectedSegment?.customers || [];

const filteredCustomers = sourceCustomers.filter((c) => {
  const q = search.toLowerCase();
  return (
  c.name.toLowerCase().includes(q) ||
  c.email.toLowerCase().includes(q) ||
  (c.phone || "").toLowerCase().includes(q) ||
  c.location.toLowerCase().includes(q)
);
});

const totalCustomers = filteredCustomers.length;

const totalPages = Math.ceil(totalCustomers / perPage);

const paginatedCustomers = filteredCustomers.slice(
  (page - 1) * perPage,
  page * perPage
);

const printRef = React.useRef();

const getTitleSize = (text) => {
  const length = text.length;

  if (length < 25) return "text-[18px]";
  if (length < 40) return "text-[16px]";
  if (length < 60) return "text-[14px]";
  if (length < 80) return "text-[13px]";
  return "text-[10px]";
};

const titleText = bulkMode
  ? `${selectedSegments.map(s => s.name).join(" + ")} (${bulkType?.toUpperCase()})`
  : selectedSegment
  ? selectedSegment.name
  : t("Segments", "الشرائح");
  
  const openEmailCampaignModal = () => {
  const initialSelected = {};

  filteredCustomers.forEach((c) => {
    if (c.email) {
      initialSelected[c.id] = true;
    }
  });

  setSelectedEmails(initialSelected);
  setEmailSubject("");
  setEmailBody("");
  setEmailError("");
  setEmailSuccess("");
  setShowEmailModal(true);
};

const getSelectedEmailRecipients = () => {
  return filteredCustomers
    .filter((c) => c.email && selectedEmails[c.id])
    .map((c) => ({
      id: c.id,
      name: c.name,
      email: c.email,
    }));
};

const handleSendSegmentEmails = async () => {
  const subject = emailSubject.trim();
  const body = emailBody.trim();
  const recipients = getSelectedEmailRecipients();

  setEmailError("");
  setEmailSuccess("");

  if (!subject) {
    setEmailError(t("Please write an email subject.", "يرجى كتابة موضوع البريد."));
    return;
  }

  if (!body) {
    setEmailError(t("Please write an email message.", "يرجى كتابة رسالة البريد."));
    return;
  }

  if (!recipients.length) {
    setEmailError(t("Please select at least one recipient.", "يرجى اختيار مستلم واحد على الأقل."));
    return;
  }

  try {
    setEmailSending(true);

    const result = await sendSegmentEmailCampaign({
      subject,
      body,
      recipients,
    });

    setEmailSuccess(
      t(
        `Emails sent successfully to ${result.sent || recipients.length} customers.`,
        `تم إرسال البريد بنجاح إلى ${result.sent || recipients.length} عملاء.`
      )
    );

    setTimeout(() => {
      setShowEmailModal(false);
      setEmailSuccess("");
      setEmailSubject("");
      setEmailBody("");
      setSelectedEmails({});
    }, 1200);
  } catch (err) {
    setEmailError(
      err?.message ||
        t("Failed to send emails.", "فشل إرسال البريد.")
    );
  } finally {
    setEmailSending(false);
  }
};

  return (
    <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "EN" ? "lg:ml-64" : ""} w-full`}>
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="p-4 sm:p-6 animate-fadeSlide">
         <div className="flex items-center justify-between mb-5 gap-3">

  {/* LEFT */}
  <div className="flex items-center gap-2 min-w-0 flex-1 max-w-full md:max-w-[70%]">

    <FaUsers className="text-gray-900 text-[18px] shrink-0" />

    <h1
  className={`
    font-semibold text-gray-900
    ${getTitleSize(titleText)}
    truncate
    block
    max-w-full
  `}
  title={titleText}
>
      {titleText}
    </h1>

  </div>

  {/* RIGHT */}
  {(selectedSegment || bulkMode) && (
    <div className="relative shrink-0 ml-2 md:ml-2 mr-0 md:mr-0">

      <button
        onClick={() => setShowActions(v => !v)}
        className="
          actions-button
          flex items-center gap-1
          h-8 px-3
          bg-[#f6f6f7]
          border border-gray-300
          rounded-lg
          shadow-[0_1px_0_rgba(0,0,0,0.04),0_2px_5px_rgba(0,0,0,0.06)]
          text-sm font-medium text-gray-900
          hover:bg-gray-100
          transition
        "
      >
        {t("More actions", "المزيد من الإجراءات")}
        <span className="rotate-90 text-gray-500 text-sm">›</span>
      </button>

      {showActions && (
      <div className="
  actions-overlay
  absolute right-0 top-full mt-1
  w-52
  bg-white
  border border-[#e3e3e3]
  rounded-xl
  shadow-[0_20px_40px_rgba(0,0,0,0.12)]
  z-50
  overflow-hidden
  animate-fadeSlide
">

  {/* EXPORT */}
  <button
    onClick={() => {
      setShowExport(true);
      setShowActions(false);
    }}
    className="group w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-gray-50"
  >
    <div className="flex items-center gap-2">
      <FiDownload className="text-[14px] text-gray-600" />
      <span className="font-medium">{t("Export", "تصدير")}</span>
    </div>
    <FiChevronRight className="text-gray-400 group-hover:translate-x-1 transition" />
  </button>

  {/* EMAIL */}
  <button
    onClick={() => {
  openEmailCampaignModal();
  setShowActions(false);
}}
    className="group w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-gray-50"
  >
    <div className="flex items-center gap-2">
      <FiMail className="text-[14px] text-gray-600" />
      <span>{t("Email campaign", "حملة بريد إلكتروني")}</span>
    </div>
    <FiChevronRight className="text-gray-400 group-hover:translate-x-1 transition" />
  </button>

  {/* WHATSAPP */}
  <button
    onClick={() => {
      setShowWhatsAppModal(true);
      setShowActions(false);
    }}
    className="group w-full flex items-center justify-between px-3 py-2 text-sm hover:bg-gray-50"
  >
    <div className="flex items-center gap-2">
      <FiMessageCircle className="text-[14px] text-gray-600" />
      <span>{t("WhatsApp campaign", "حملة واتساب")}</span>
    </div>
    <FiChevronRight className="text-gray-400 group-hover:translate-x-1 transition" />
  </button>

</div>
      )}
    </div>
  )}

</div>

          <div className="bg-white border border-[#e3e3e3] rounded-[14px] overflow-visible shadow-[0_12px_32px_rgba(0,0,0,0.10),0_2px_6px_rgba(0,0,0,0.06)]">
            <div className="relative flex items-center justify-between px-4 py-3 border-b border-[#e3e3e3] bg-white rounded-t-[14px]">

  {/* LEFT */}
  <div className="flex items-center gap-2">

    {(selectedSegment || bulkMode) && (
      <button
        onClick={() => {
          setSelectedSegment(null);
          setBulkMode(false);
          setBulkType(null); 
          setSelectedSegments([]);
          setSearch("");
        }}
        className="h-9 px-3 bg-white border border-gray-300 rounded-lg text-sm hover:bg-gray-50"
      >
        {t("Back", "رجوع")}
      </button>
    )}

{/* SINGLE SELECT VIEW */}
{!selectedSegment && selectedSegments.length === 1 && !bulkMode && (
  <button
    onClick={() => {
      setBulkType("or"); // default behavior
      setBulkMode(true);
    }}
    className="h-8 px-3 text-sm rounded-lg bg-[#202223] text-white hover:bg-black shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.2)]"
  >
    {t("View", "عرض")} (1)
  </button>
)}

    {/* BULK BUTTON */}
    {!selectedSegment && selectedSegments.length > 1 && !bulkMode && (
  <div className="flex items-center gap-2">

  {/* TOGGLE */}
  <div className="flex items-center bg-[#f6f6f7] p-[2px] rounded-lg border border-[#e3e3e3]">

    <button
      onClick={() => setBulkType("or")}
      className={`
        px-3 h-8 text-[13px] rounded-md font-medium transition
        ${bulkType === "or"
          ? "bg-white shadow text-gray-900"
          : "text-gray-600 hover:text-black"}
      `}
    >
      OR
    </button>

    <button
      onClick={() => setBulkType("and")}
      className={`
        px-3 h-8 text-[13px] rounded-md font-medium transition
        ${bulkType === "and"
          ? "bg-white shadow text-gray-900"
          : "text-gray-600 hover:text-black"}
      `}
    >
      AND
    </button>

  </div>

  <div className="flex items-center gap-2 relative group">

  {/* VIEW BUTTON */}
  <button
    onClick={() => setBulkMode(true)}
    disabled={!bulkType}
    className={`
      h-8 px-3 text-sm rounded-lg font-medium transition
      ${bulkType
        ? "bg-[#202223] text-white hover:bg-black shadow-[0_1px_0_rgba(0,0,0,0.08),0_3px_8px_rgba(0,0,0,0.2)]"
        : "bg-gray-200 text-gray-400 cursor-not-allowed"}
    `}
  >
   {t("View", "عرض")} ({selectedSegments.length})
  </button>

 <div className="relative group flex items-center">

  {/* ICON */}
  <div className="
    w-5 h-5 flex items-center justify-center
    text-[11px] font-semibold
    rounded-full
    bg-gray-200 text-gray-900
    cursor-default
  ">
    ?
  </div>

  {/* TOOLTIP */}
  <div className="
    absolute top-full mt-2 left-1/2 -translate-x-1/2
    w-[260px]
    bg-white border border-gray-200
    rounded-lg shadow-[0_12px_24px_rgba(0,0,0,0.15)]
    p-3 text-xs text-gray-900
    opacity-0 pointer-events-none
    group-hover:opacity-100 group-hover:pointer-events-auto
    transition
    z-50
  ">

    <div className="mb-2">
      <span className="font-semibold">AND → </span>
      {t(
  "will display customers who match",
  "سيعرض العملاء الذين يطابقون"
)}{" "}
      <b>{segmentNamesAND || "all selected segments"}</b>
    </div>

    <div>
      <span className="font-semibold">OR → </span>
      {t(
  "will display customers who match",
  "سيعرض العملاء الذين يطابقون"
)}{" "}
      <b>{t("any of", "أي من")} {segmentNamesOR || "selected segments"}</b>
    </div>

  </div>
</div>

</div>

</div>
)}
  </div>

  {/* RIGHT */}
  <div className="flex items-center gap-2">

{(selectedSegment || bulkMode) && (
  <div className="relative">
  </div>
)}

    {/* SEGMENT SEARCH */}
    {!selectedSegment && !bulkMode && (
      <div className="flex items-center h-9 px-3 bg-white border border-gray-300 rounded-lg shadow-sm">
        <FaSearch className="text-gray-400 text-sm" />
        <input
          value={segmentSearch}
          onChange={(e) => setSegmentSearch(e.target.value)}
          placeholder={t("Search segments...", "ابحث في الشرائح...")}
          className="ml-2 outline-none text-sm"
        />
      </div>
    )}

    {/* CUSTOMER SEARCH */}
    {(selectedSegment || bulkMode) && (
      <div className="flex items-center h-9 px-3 bg-white border border-gray-300 rounded-lg shadow-sm">
        <FaSearch className="text-gray-400 text-sm" />
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder={t("Search customers...", "ابحث عن العملاء...")}
          className="ml-2 outline-none text-sm"
        />
      </div>
    )}
  </div>
</div>

            {!selectedSegment && !bulkMode ? (
  <>
    {/* DESKTOP TABLE */}
    <div className="hidden md:block">
      <table className="w-full min-w-[760px]">
                <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
                  <tr>
                    <th className="p-3 text-center">
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={toggleAllSegments}
                        className="w-4 h-4 accent-gray-800"
                        />
                    </th>
                    <th className="p-3 text-start">{t("Name", "الاسم")}</th>
                    <th className="p-3 text-center">{t("% of customers", "نسبة العملاء")}</th>
                    <th className="p-3 text-center">{t("Number of customers", "عدد العملاء")}</th>
                  </tr>
                </thead>

                <tbody>
                 {loading ? (
  [...Array(6)].map((_, i) => (
    <tr key={i} className="animate-pulse border-b">
      <td className="p-3 text-center">
        <div className="w-4 h-4 bg-gray-200 rounded mx-auto" />
      </td>
      <td className="p-3">
        <div className="h-3 w-32 bg-gray-200 rounded" />
      </td>
      <td className="p-3 text-center">
        <div className="h-3 w-16 bg-gray-200 rounded mx-auto" />
      </td>
      <td className="p-3 text-center">
        <div className="h-3 w-20 bg-gray-200 rounded mx-auto" />
      </td>
    </tr>
  ))
) : filteredSegments.length === 0 ? (
  <tr>
    <td colSpan="4" className="p-8 text-center text-gray-500">
      {t("No segments found", "لم يتم العثور على شرائح")}
    </td>
  </tr>
) : (
                    filteredSegments.map((s) => {
  const checked = selectedSegments.some((x) => x.id === s.id);

  return (
    <tr
      key={s.id}
      onClick={() => setSelectedSegment(s)}
      className="border-b border-[#f1f1f1] hover:bg-[#f6f6f7] cursor-pointer transition text-[13px]"
    >
      <td
        className="p-3 text-center"
        onClick={(e) => {
          e.stopPropagation();
          toggleSegment(s);
        }}
      >
        <input
          type="checkbox"
          checked={checked}
          readOnly
          className="w-4 h-4 accent-gray-800"
        />
      </td>

      <td className="p-3 font-semibold text-gray-900">{s.name}</td>
      <td className="p-3 text-center">{s.percent}%</td>
      <td className="p-3 text-center">{s.customersCount}</td>
    </tr>
  );
})
                  )}
                </tbody>
              </table>
              </div>
                  {/* MOBILE SEGMENTS VIEW */}
    <div className="md:hidden space-y-2">
      {loading ? (
        [...Array(4)].map((_, i) => (
          <div key={i} className="animate-pulse bg-white p-3 rounded-lg border">
            <div className="h-3 w-32 bg-gray-200 rounded mb-2" />
            <div className="h-3 w-20 bg-gray-200 rounded" />
          </div>
        ))
      ) : filteredSegments.length === 0 ? (
        <div className="text-center text-gray-500 py-6">
          {t("No segments found", "لم يتم العثور على شرائح")}
        </div>
      ) : (
        filteredSegments.map((s) => (
          <div
            key={s.id}
            onClick={() => setSelectedSegment(s)}
            className="bg-white p-3 rounded-lg border shadow-sm"
          >
            <div className="font-semibold">{s.name}</div>
            <div className="text-xs text-gray-500 mt-1">
              {s.percent}% • {s.customersCount} {t("customers", "عميل")}
            </div>
          </div>
        ))
      )}
    </div>
  </>
) : (
  <>
    {/* DESKTOP TABLE */}
    <div className="hidden md:block">
      <table className="w-full min-w-[860px]">
                <thead className="bg-[#f6f6f7] text-[#6d7175] text-[13px] font-medium">
                  <tr>
                    <th className="p-3 text-start">{t("Customer name", "اسم العميل")}</th>
                    <th className="p-3 text-center">{t("Email subscription", "اشتراك البريد")}</th>
                    <th className="p-3 text-center">{t("Phone", "رقم الهاتف")}</th>
                    <th className="p-3 text-center">{t("Location", "الموقع")}</th>
                    <th className="p-3 text-center">{t("Orders", "الطلبات")}</th>
                    <th className="p-3 text-center">{t("Amount spent", "إجمالي الإنفاق")}</th>
                  </tr>
                </thead>

                <tbody>
  {loading ? (
    [...Array(6)].map((_, i) => (
      <tr key={i} className="animate-pulse border-b">
        <td className="p-3"><div className="h-3 w-24 bg-gray-200 rounded" /></td>
        <td className="p-3"><div className="h-3 w-32 bg-gray-200 rounded mx-auto" /></td>
        <td className="p-3"><div className="h-3 w-20 bg-gray-200 rounded mx-auto" /></td>
        <td className="p-3"><div className="h-3 w-20 bg-gray-200 rounded mx-auto" /></td>
        <td className="p-3"><div className="h-3 w-10 bg-gray-200 rounded mx-auto" /></td>
        <td className="p-3"><div className="h-3 w-16 bg-gray-200 rounded mx-auto" /></td>
      </tr>
    ))
  ) : filteredCustomers.length === 0 ? (
                    <tr>
  <td colSpan="6" className="p-10 text-center text-gray-500">
    <div className="flex flex-col items-center gap-2">
      <FaUsers className="text-2xl opacity-40" />
      <span>{t("No customers found.", "لم يتم العثور على عملاء")}</span>
    </div>
  </td>
</tr>
                  ) : (
                    paginatedCustomers.map((c) => (
                      <tr
                        key={c.id}
                        className="border-b border-[#f1f1f1] hover:bg-[#f6f6f7] transition text-[13px]"
                      >
                        <td className="p-3 font-semibold text-gray-900">{c.name}</td>
                        <td className="p-3 text-center">
                          {c.email ? (
                            c.email
                          ) : (
                            <span className="inline-flex items-center px-2 py-[2px] rounded-md text-[11px] font-medium bg-gray-100 text-gray-600">
                              {t("Not subscribed", "غير مشترك")}
                            </span>
                          )}
                        </td>
                        <td className="p-3 text-center">
                          {c.phone || "—"}
                        </td>
                        <td className="p-3 text-center">{c.location || "—"}</td>
                        <td className="p-3 text-center">{c.orders}</td>
                        <td className="p-3 text-center font-semibold text-green-700">
                          ${c.totalSpent}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
          <tfoot>
  <tr className="bg-[#f6f6f7] border-t border-[#e3e3e3]">
    <td colSpan="6" className="px-4 py-2 rounded-b-[14px]">

      <div className="flex items-center justify-between text-sm text-gray-600">

        {/* COUNT */}
        <span className="text-gray-500 text-sm">
          {totalCustomers} {t("customers", "عميل")}
        </span>

        {/* PAGINATION */}
        <div className="flex items-center gap-0.5">

          <button
            onClick={() => setPage(p => Math.max(1, p - 1))}
            disabled={page === 1}
            className={`w-7 h-7 flex font-bold items-center justify-center rounded-md border bg-gray-200 ${
              page === 1
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-gray-300"
            }`}
          >
            {"<"}
          </button>

          <button
            onClick={() =>
              setPage(p => Math.min(totalPages || 1, p + 1))
            }
            disabled={page === totalPages || totalPages === 0}
            className={`w-7 h-7 flex items-center font-bold justify-center rounded-md border bg-gray-200 ${
              page === totalPages || totalPages === 0
                ? "opacity-40 cursor-not-allowed"
                : "hover:bg-gray-300"
            }`}
          >
            {">"}
          </button>

          <span className="mx-2 text-gray-600 font-bold">
            {page}-{totalPages || 1}
          </span>

        </div>

      </div>

    </td>
  </tr>
</tfoot>
                </table>
    </div>
        {/* MOBILE CUSTOMERS VIEW */}
    <div className="md:hidden space-y-2 mt-3">
      {loading ? (
        [...Array(4)].map((_, i) => (
          <div key={i} className="animate-pulse bg-white p-3 rounded-lg border">
            <div className="h-3 w-32 bg-gray-200 rounded mb-2" />
            <div className="h-3 w-20 bg-gray-200 rounded" />
          </div>
        ))
      ) : filteredCustomers.length === 0 ? (
        <div className="text-center text-gray-500 py-6">
          {t("No customers found", "لم يتم العثور على عملاء")}
        </div>
      ) : (
        paginatedCustomers.map((c) => (
          <div key={c.id} className="bg-white p-3 rounded-lg border shadow-sm">
            <div className="font-semibold">{c.name}</div>
            <div className="text-xs text-gray-500">{c.email || "—"}</div>
            <div className="text-xs text-gray-500">{c.phone || "—"}</div>
          </div>
        ))
      )}
    </div>
  </>
)
            }

            {showExport && (
  <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">

    <div className="bg-white rounded-lg shadow-xl w-[90%] max-w-4xl max-h-[90vh] overflow-auto p-6">

    <div>
      {/* HEADER */}
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-lg font-semibold">{t("Export Customers", "تصدير العملاء")}</h2>

        <div className="flex gap-2 flex-wrap">

  <button
    onClick={() => {
  if (!printRef.current) return;

  const printContents = printRef.current.innerHTML;
  const win = window.open("", "", "width=900,height=650");

  win.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: Inter, sans-serif; padding:20px; }
          table { width:100%; border-collapse: collapse; }
          th, td { border:1px solid #ddd; padding:8px; text-align:left; }
          th { background:#f3f3f3; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

  win.document.close();
  win.focus();
  win.print();
  win.close();
}}
    className="px-3 py-1 bg-black text-white rounded"
  >
    {t("Print", "طباعة")}
  </button>

  <button
    onClick={exportCSV}
    className="px-3 py-1 border rounded"
  >
    CSV
  </button>

  <button
    onClick={exportExcel}
    className="px-3 py-1 border rounded"
  >
    Excel
  </button>

  <button
    onClick={exportPDF}
    className="px-3 py-1 border rounded"
  >
    PDF
  </button>

  <button
    onClick={() => setShowExport(false)}
    className="px-3 py-1 border rounded"
  >
    {t("Close", "إغلاق")}
  </button>

</div>
      </div>
<div ref={printRef}>
      {/* TABLE */}
      <table className="w-full text-sm border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 border">{t("Name", "الاسم")}</th>
            <th className="p-2 border">Email</th>
            <th className="p-2 border">{t("Phone", "رقم الهاتف")}</th>
            <th className="p-2 border">{t("Location", "الموقع")}</th>
            <th className="p-2 border">{t("Orders", "الطلبات")}</th>
            <th className="p-2 border">Spent</th>
          </tr>
        </thead>

        <tbody>
          {filteredCustomers.map((c) => (
            <tr key={c.id}>
              <td className="p-2 border">{c.name}</td>
              <td className="p-2 border">{c.email || "—"}</td>
              <td className="p-2 border">{c.phone || "—"}</td>
              <td className="p-2 border">{c.location || "—"}</td>
              <td className="p-2 border">{c.orders}</td>
              <td className="p-2 border">${c.totalSpent}</td>
            </tr>
          ))}
        </tbody>
      </table>
</div>
    </div>
  </div>
  </div>
)}

{showEmailModal && (
<div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">

  <div className="bg-white w-[95%] max-w-3xl rounded-xl shadow-xl overflow-hidden">

    {/* HEADER */}
    <div className="px-5 py-4 border-b flex justify-between items-center">
      <h2 className="text-[16px] font-semibold">{t("Email campaign", "حملة بريد إلكتروني")}</h2>
      <button onClick={() => setShowEmailModal(false)}>✕</button>
    </div>

    {/* CONTENT */}
    <div className="p-5 space-y-4 max-h-[70vh] overflow-auto">

      {/* SUBJECT */}
      <div>
        <label className="text-sm font-medium text-gray-600">{t("Subject", "الموضوع")}</label>
        <input
          value={emailSubject}
          onChange={(e) => setEmailSubject(e.target.value)}
          className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
          placeholder={t("Enter email subject...", "أدخل موضوع البريد...")}
        />
      </div>

      {/* BODY */}
      <div>
        <label className="text-sm font-medium text-gray-600">{t("Message", "الرسالة")}</label>
        <textarea
          value={emailBody}
          onChange={(e) => setEmailBody(e.target.value)}
          rows={4}
          className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
          placeholder={t("Write your message...", "اكتب رسالتك...")}
        />
        {emailError && (
  <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
    {emailError}
  </div>
)}

{emailSuccess && (
  <div className="rounded-lg border border-green-200 bg-green-50 px-3 py-2 text-sm text-green-700">
    {emailSuccess}
  </div>
)}
      </div>

      {/* CUSTOMER LIST */}
      <div>
        <label className="text-sm font-medium text-gray-600 mb-2 block">
          {t("Recipients", "المستلمون")}
        </label>

        <div className="border rounded-lg divide-y max-h-[250px] overflow-auto">
          {filteredCustomers.map(c => (
            <div key={c.id} className="flex items-center justify-between px-3 py-2">

              <div>
                <div className="text-sm font-medium">{c.name}</div>
                <div className="text-xs text-gray-500">{c.email || "—"}</div>
              </div>

              <button
                onClick={() => toggleEmail(c.id)}
                className={`
                  w-10 h-5 rounded-full transition
                  ${selectedEmails[c.id] ? "bg-black" : "bg-gray-300"}
                `}
              >
                <div className={`
                  w-4 h-4 bg-white rounded-full transition
                  ${selectedEmails[c.id] ? "translate-x-5" : "translate-x-1"}
                `} />
              </button>

            </div>
          ))}
        </div>
      </div>

    </div>

    {/* FOOTER */}
    <div className="px-5 py-4 border-t flex justify-end gap-2">
      <button
        onClick={() => setShowEmailModal(false)}
        className="px-4 py-2 border rounded-lg text-sm"
      >
        {t("Cancel", "إلغاء")}
      </button>

      <button
  onClick={handleSendSegmentEmails}
  disabled={emailSending}
  className="
    px-4 py-2
    bg-black
    text-white
    rounded-lg
    text-sm
    disabled:opacity-60
    disabled:cursor-wait
  "
>
  {emailSending
    ? t("Sending...", "جارٍ الإرسال...")
    : t("Send emails", "إرسال البريد")}
</button>
    </div>

  </div>
</div>
)}

{showWhatsAppModal && (
<div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center">

  <div className="bg-white w-[95%] max-w-2xl rounded-xl shadow-xl overflow-hidden">

    {/* HEADER */}
    <div className="px-5 py-4 border-b flex justify-between items-center">
      <h2 className="text-[16px] font-semibold">{t("WhatsApp campaign", "حملة واتساب")}</h2>
      <button onClick={() => setShowWhatsAppModal(false)}>✕</button>
    </div>

    {/* CONTENT */}
    <div className="p-5 space-y-4 max-h-[70vh] overflow-auto">

      {/* MESSAGE */}
      <div>
        <label className="text-sm font-medium text-gray-600">{t("Message", "الرسالة")}</label>
        <textarea
          value={whatsappMessage}
          onChange={(e) => setWhatsappMessage(e.target.value)}
          rows={3}
          className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
          placeholder={t("Write your WhatsApp message...", "اكتب رسالة واتساب...")}
        />
      </div>

      {/* LIST */}
      <div className="border rounded-lg divide-y">

        {filteredCustomers.map(c => (
          <div key={c.id} className="flex items-center justify-between px-3 py-2">

            <div>
              <div className="text-sm font-medium">{c.name}</div>
              <div className="text-xs text-gray-500">{c.phone || "—"}</div>
            </div>

            <button
              onClick={() => handleSendWhatsApp(c.id)}
              disabled={sentWhatsApp[c.id]}
              className={`
                px-3 py-1 rounded-lg text-sm
                ${sentWhatsApp[c.id]
                  ? "bg-gray-200 text-gray-500"
                  : "bg-black text-white hover:bg-gray-800"}
              `}
            >
              {sentWhatsApp[c.id] ? t("Sent ✓", "تم الإرسال ✓") : t("Send", "إرسال")}
            </button>

          </div>
        ))}

      </div>

    </div>

  </div>
</div>
)}

          </div>
          <div className="md:hidden mt-4 px-2">
  <div className="flex items-center justify-between bg-white border rounded-lg px-3 py-2 shadow-sm">

    {/* PREV */}
    <button
      onClick={() => setPage(p => Math.max(1, p - 1))}
      disabled={page === 1}
      className={`px-3 py-1 rounded-md border ${
        page === 1 ? "opacity-40" : "bg-gray-100"
      }`}
    >
      {t("Prev", "السابق")}
    </button>

    {/* PAGE */}
    <span className="text-sm font-medium text-gray-600">
      {page} / {totalPages || 1}
    </span>

    {/* NEXT */}
    <button
      onClick={() =>
        setPage(p => Math.min(totalPages || 1, p + 1))
      }
      disabled={page === totalPages || totalPages === 0}
      className={`px-3 py-1 rounded-md border ${
        page === totalPages ? "opacity-40" : "bg-gray-100"
      }`}
    >
      {t("Next", "التالي")}
    </button>

  </div>
</div>
        </main>
      </div>
    </div>
  );
}

export default AdminSegments;